import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { collection, getDocs, query, orderBy, limit } from "firebase/firestore";
import { db } from "../../firebase";

import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";

import "./FeaturedAds.css";
import { slugify } from '../../utils/helpers';

export const FeaturedAds = ({
  showHeading = true,
  showExploreButton = true,
}) => {
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);

  const [emblaRef] = useEmblaCarousel(
    { loop: true, align: "start" },
    [Autoplay({ delay: 3000, stopOnInteraction: false })]
  );

  useEffect(() => {
    const fetchFeaturedAds = async () => {
      try {
        const adsRef = collection(db, "listings");
        const q = query(adsRef, orderBy("createdAt", "desc"), limit(10));
        const querySnapshot = await getDocs(q);

        const adsData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data()
        }));

        setAds(adsData);
      } catch (error) {
        console.error("Error fetching featured ads:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedAds();
  }, []);

  if (!loading && ads.length === 0) return null;

  return (
    <section className="featured-ads-section">
      <div className="container">

        {showHeading && (
          <div className="featured-header">
            <h2 className="section-title">Fresh Local Deals</h2>
            <p className="section-subtitle">
              Just listed in your neighborhood.
            </p>
          </div>
        )}



        {loading ? (
          <div className="loading-placeholder">Loading latest deals...</div>
        ) : (
          <div className="embla">
            <div className="embla__viewport" ref={emblaRef}>
              <div className="embla__container">

                {ads.map((ad) => {

                  const image =
                    ad.images?.[0] ||
                    ad.photos?.[0]?.thumb ||
                    ad.photos?.[0] ||
                    "https://via.placeholder.com/300?text=No+Image";

                  return (
                    <div className="embla__slide" key={ad.id}>
                      <Link to={`/item/${ad.id}/${slugify(ad.title)}`} key={ad.id} className="scroll-ad-card">

                        <div className="scroll-ad-image-box">
                          <img
                            src={image}
                            alt={ad.title}
                            className="scroll-ad-img"
                          />
                          <div className="scroll-ad-price">
                            ₹ {ad.price}
                          </div>
                        </div>

                        <div className="scroll-ad-info">
                          <h4 className="scroll-ad-title">{ad.title}</h4>
                          <span className="scroll-ad-location">
                            📍 {ad.location || "Nearby"}
                          </span>
                        </div>

                      </Link>
                    </div>
                  );
                })}

              </div>
            </div>
          </div>
        )}

        {showExploreButton && (
          <div className="explore-more-container">
            <Link to="/explore" className="btn btn-primary-glossy explore-btn">
              See All Ads →
            </Link>
          </div>
        )}


      </div>
    </section>
  );
};